import * as Sentry from "@sentry/browser";
import type { JSX } from "react";
import { useQuery } from "urql";
import Loader from "../../shared/components/Loader";
import { loadJSData } from "../../shared/jsData";
import { useSelectedIds } from "../components/SelectedIds";
import ShowError from "../components/ShowError";
import type { OpenLockedModal } from "../LockedModal";
import AllTasks from "./AllTasks";
import CustomTasks from "./CustomTasks";
import { query } from "./query";
import type { ITab } from "./Tabs";

interface IProps {
    tab: ITab;
    openLockedModal: OpenLockedModal;
    activeItem?: string;
    onNavigate: () => void;
}

function TasksSidebar({ tab, openLockedModal, activeItem, onNavigate }: IProps): JSX.Element {
    const selectedIds = useSelectedIds();
    const [result] = useQuery({
        query,
        variables: { id: selectedIds.pathId },
        pause: !selectedIds.pathId,
    });
    if (!selectedIds.pathId) {
        Sentry.captureMessage("Missing pathId in TasksSidebar.", { level: "error", extra: { ...selectedIds } });
    }
    if (result.fetching) {
        return <Loader />;
    }
    if (result.error) {
        return <ShowError />;
    }
    const path = result.data?.learningPath;
    return (
        <>
            {tab === "tasks" && (
                <AllTasks
                    path={path}
                    openLockedModal={openLockedModal}
                    activeItem={activeItem}
                    onNavigate={onNavigate}
                />
            )}
            {loadJSData().features.custom_tasks && tab === "custom" && (
                <CustomTasks path={path} activeItem={activeItem} onNavigate={onNavigate} />
            )}
        </>
    );
}

export default TasksSidebar;
